var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("text-" + (_vm.data.align) + " mt-3")},[_c('span',{style:("color: " + (_vm.data.fontColor) + "; font-size:" + (_vm.data.fontSize) + ";" +
        (_vm.data.bold ? 'font-weight: bold;' : '') +
        (_vm.data.underline ? 'text-decoration: underline;' : '') +
        (_vm.data.italic ? ' font-style: italic;' : ''))},[_vm._v(" "+_vm._s(_vm.data.textTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }